var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.25H12",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25H9",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.125V15.75C9.75 13.6287 9.75 12.5681 10.409 11.909C11.0681 11.25 12.1287 11.25 14.25 11.25H14.625M15 10.0073V7.5C15 4.67157 15 3.25736 14.1213 2.37868C13.2427 1.5 11.8284 1.5 9 1.5C6.17158 1.5 4.75736 1.5 3.87868 2.37868C3 3.25736 3 4.67157 3 7.5V10.9081C3 13.3419 3 14.5588 3.66455 15.383C3.79881 15.5495 3.95048 15.7012 4.117 15.8354C4.94123 16.5 6.15811 16.5 8.59185 16.5C9.12105 16.5 9.38558 16.5 9.6279 16.4145C9.6783 16.3967 9.72765 16.3763 9.77588 16.3532C10.0077 16.2423 10.1947 16.0553 10.5689 15.6811L14.1213 12.1287C14.5549 11.6951 14.7716 11.4784 14.8858 11.2027C15 10.9271 15 10.6204 15 10.0073Z",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanicon);
export default __webpack_public_path__ + "static/media/plan icon.4528442acdd3d68c250ca457b213fc97.svg";
export { ForwardRef as ReactComponent };